import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EyeOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import { txt } from 'libs/i18n';
import IconButton from 'components/IconButton';
import { useSession } from 'components/Authenticated';
import { deleteSpeaker } from 'api/speaker-api-v2';
import { deleteSpeakerLocalization } from 'screens/DashboardScreen/components/SpeakerModal/speaker-actions';
const SpeakerRowActions = ({ record, languages, onOpenModal, onRefetch, }) => {
    const { session } = useSession();
    if (record.rowType === 'variant') {
        return null;
    }
    const isOneLanguage = languages !== undefined && languages.length === 1;
    const showDetail = record.rowType === 'speaker' || isOneLanguage;
    const isLocalization = record.rowType === 'localization';
    return (_jsxs("div", { style: { display: 'flex', justifyContent: 'flex-end' }, children: [showDetail && (_jsx(IconButton, { onClick: () => onOpenModal({ mode: 'detail', id: record.uniqueId }), children: _jsx(EyeOutlined, {}) })), record.rowType === 'localization' && (_jsx(IconButton, { onClick: () => { var _a; return onOpenModal({ mode: 'edit', id: record.uniqueId, languages: (_a = record.locale) !== null && _a !== void 0 ? _a : null }); }, children: _jsx(EditOutlined, {}) })), _jsx(Popconfirm, { title: txt('deleteSpeaker'), onConfirm: async () => {
                    var _a;
                    if (record.rowType === 'speaker') {
                        const result = await deleteSpeaker(session.connection, record.uniqueId);
                        if (result.isSuccess())
                            await onRefetch();
                    }
                    else if (isLocalization) {
                        const success = await deleteSpeakerLocalization(session.connection, record.uniqueId, (_a = record.locale) === null || _a === void 0 ? void 0 : _a.code);
                        if (success)
                            await onRefetch();
                    }
                }, okText: txt('delete'), okType: "primary", okButtonProps: { danger: true }, cancelText: txt('cancel'), children: _jsx(IconButton, { danger: true, children: _jsx(DeleteOutlined, {}) }) })] }));
};
export default SpeakerRowActions;
